import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import pt from './locales/pt.json';
import es from './locales/es.json';

// Get language from URL parameter
const getInitialLanguage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  if (langParam && ['en', 'pt', 'es'].includes(langParam.toLowerCase())) {
    return langParam.toLowerCase();
  }
  return null;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pt: { translation: pt },
      es: { translation: es }
    },
    lng: getInitialLanguage() || localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
      cookieMinutes: 160,
    }
  });

// Update URL when language changes
i18n.on('languageChanged', (lng) => {
  const url = new URL(window.location.href);
  url.searchParams.set('lang', lng);
  window.history.pushState({}, '', url.toString());
});

export default i18n;
